"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const setIconColor = variant => {
  switch (variant) {
    case 'invisible':
    case 'white':
      {
        return 'text.2';
      }

    default:
      return 'text.3';
  }
};

const Chevron = ({
  type,
  variant,
  ...other
}) => {
  const iconColor = setIconColor(variant);
  return (0, _pragma.createFelaElement)(_.ButtonIcon, _extends({
    "aria-label": "carousel-action-".concat(type),
    variant: variant
  }, other), type === 'left' ? (0, _pragma.createFelaElement)(_.ChevronLeftIcon, {
    size: "large",
    color: iconColor
  }) : (0, _pragma.createFelaElement)(_.ChevronRightIcon, {
    size: "large",
    color: iconColor
  }));
};

var _default = Chevron;
exports.default = _default;
//# sourceMappingURL=Chevron.js.map